export type ShiftFilterType = "ActiveShifts" | "TimeoffShifts" | "ConflictingShifts";
export const ShiftFilterTypes = {
    ActiveShifts: "ActiveShifts" as ShiftFilterType,
    TimeoffShifts: "TimeoffShifts" as ShiftFilterType,
    ConflictingShifts: "ConflictingShifts" as ShiftFilterType
};